import React from 'react';
import { useTranslation } from 'react-i18next';

const CareerPeriods = ({dateItems, selectedPeriod, setPeriod}) => {
    const { t } = useTranslation();
    return (
        <div className={"periodContainer"}>
            <div className={"periodSection"}>
                {
                    dateItems.map((item, index) =>
                        <div key={index} className={`period ${(item === selectedPeriod) ? 'selected' : ''}`} onClick={() => setPeriod(item)}>
                            <span>{t(`career.periods.${item}`)}</span>
                        </div>)
                }
            </div>
        </div>
    )
}

export default CareerPeriods;